import { useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import RevenueCard from "./components/RevenueCard";
import MDButton from "components/MDButton";
import CircularIndeterminate from "components/MDLoading";
import { getRevenueComparison } from "store/slice/revenueComparison/revenueComparisonSlice";
import { useDispatch } from "react-redux";
import MDSnackbar from "components/MDSnackbar";
import moment from "moment";

function RevenueComparison() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const dispatch = useDispatch();
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification({ ...notification, show: false }),
  });
  const [leftFilters, setLeftFilters] = useState({});
  const [rightFilters, setRightFilters] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [leftData, setLeftData] = useState({});
  const [rightData, setRightData] = useState({});
  const [hasSubmitted, setHasSubmitted] = useState(false);

  // Validate required fields
  const validateFilters = (filters) => {
    return (
      Array.isArray(filters.placeId) &&
      filters.placeId.length > 0 &&
      !!filters.startDate &&
      !!filters.endDate &&
      !!filters.tz
    );
  };

  const handleGetRevenue = async () => {
    setHasSubmitted(true);

    // Prevent API call if validation fails
    if (!validateFilters(leftFilters) || !validateFilters(rightFilters)) {
      console.warn("Validation failed. API not called.");
      return;
    }

    const payload = {
      firstCardKeys: {
        ...leftFilters,
        startDate: moment(leftFilters.startDate)
          .format("YYYY-MM-DD HH:mm")
          .toString(),
        endDate: moment(leftFilters.endDate).format("YYYY-MM-DD HH:mm").toString(),
      },
      secondCardKeys: {
        ...rightFilters,
        startDate: moment(rightFilters.startDate)
          .format("YYYY-MM-DD HH:mm")
          .toString(),
        endDate: moment(rightFilters.endDate).format("YYYY-MM-DD HH:mm").toString(),
      },
    };

    try {
      setIsLoading(true);
      dispatch(getRevenueComparison(payload))
        .unwrap()
        .then((res) => {
          const success = res?.success;
          if (success) {
            setLeftData(res.data.firstCardData || {});
            setRightData(res.data.secondCardData || {});
            setIsLoading(false);
          } else {
            setNotification({
              ...notification,
              color: "error",
              title: "Error",
              content: res?.message,
              icon: "warning",
              show: true,
            });
            setIsLoading(false);
          }
        });
    } catch (error) {
      setNotification({
        ...notification,
        color: "error",
        title: "Error",
        content: error?.message,
        icon: "warning",
        show: true,
      });
      setIsLoading(false);
    }
  };

  console.log("isLoading ===>", isLoading);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <CircularIndeterminate
              type="full"
              size={20}
              text={`Fetching revenue.....`}
              open={isLoading}
            />
            <MDSnackbar
              color={notification.color}
              icon={notification.icon}
              title={notification.title}
              content={notification.content}
              open={notification.show}
              close={notification.close}
              bgWhite
            />
            <MDBox
              mx={1}
              mt={-2}
              py={1}
              px={1}
              variant="gradient"
              bgColor={sidenavColor}
              borderRadius="lg"
              coloredShadow={sidenavColor}
              className="d-flex align-items-center gap-2"
            >
              <MDTypography variant="h6" color="white" className="flex-grow-1">
                Revenue Comparison
              </MDTypography>
            </MDBox>

            <MDBox p={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <RevenueCard
                    onFilterChange={setLeftFilters}
                    revenueData={leftData}
                    hasSubmitted={hasSubmitted}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <RevenueCard
                    onFilterChange={setRightFilters}
                    revenueData={rightData}
                    hasSubmitted={hasSubmitted}
                  />
                </Grid>
              </Grid>
            </MDBox>

            <MDBox p={2} className="text-center">
              <MDButton
                color={sidenavColor}
                variant="contained"
                size="small"
                onClick={handleGetRevenue}
              >
                Get Revenue
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default RevenueComparison;
